import { useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Modal from "../../../myfin_v2/elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { Button } from "../../../myfin_v2/elements/Button";
import commoncss from "../../../myfin_v2/css/common.module.css"

import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import CustomDropdownIndicator from "../../../myfin_v2/elements/CustomDropdownIndicator";
import { createAuthorizedCapital, updateAuthorizedCapital } from "../../../WorkSpace/Components/ApiServices/apiHandler";

export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        borderColor: '#c2e6d1',
        color: '#b3c0bd',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderWidth: '1px',
        borderRadius: '10px',
        '&:hover': {
            borderColor: '#b3c0bd',
        },
        minHeight: '38px',
        height: '38px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 8px',
        paddingTop: '1px',
    }),
    input: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '14px',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4d6d64',
        fontSize: '14px',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9',
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#4d6d64',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1A4338',
        fontWeight: 400,
        ':hover': {
            color: '#1A4338',
            fontWeight: 400,
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            color: '#4f665f',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 0 0 1px #c2e6d1',
        marginTop: '6px',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#c2e6d1'
            : state.isFocused
                ? '#f4faf5'
                : 'transparent',
        color: '#4f665f',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '8px',
        // margin: '4px 6px',
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};


const AuthorizedCapitalModal = ({ handleClose, data, type, classOfShareOptions, investmentID, refreshData, companyId }) => {

    const animatedComponents = makeAnimated();

    const [selectedClassOfShare, setSelectedClassOfShare] = useState(
        type === "edit" && data?.classOfShare
        ? { label: data.classOfShare, value: data.classOfShare }
        : null
    );

     const [noOfShares, setNoOfShares] = useState(
            type === "edit" ? data?.noOfShares : ""
        );

        const [faceValue, setFaceValue] = useState(
            type === "edit" ? data?.faceValue : ""
        );

        const [amount, setAmount] = useState(
            type === "edit" ? data?.amount : ""
        );

        const [loading, setLoading] = useState(false);

        const handleSubmit = async () => {
  if (!selectedClassOfShare || !noOfShares || !faceValue) {
    alert("Please fill all required fields");
    return;
  }

  try {
    setLoading(true);

    const payload = {
      companyID: companyId,
      classOfShare: selectedClassOfShare.value,
      noOfShares: Number(noOfShares),
      faceValue: Number(faceValue),
      amount: Number(amount),
    };

    let res;

    if (type === "edit") {
      res = await updateAuthorizedCapital(
        investmentID,
        data._id,
        payload
      );
    } else {
      res = await createAuthorizedCapital(investmentID, payload);
    }

    if (res?.data?.success) {
      alert(
        type === "edit"
          ? "Authorized Capital Updated "
          : "Authorized Capital Created "
      );
      refreshData();
      handleClose();
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong ❌");
  } finally {
    setLoading(false);
  }
};

    return(
        <>
            <style>
                {`
                    input.no-spinner::-webkit-outer-spin-button,
                    input.no-spinner::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }

                    input.no-spinner[type=number] {
                        -moz-appearance: textfield; /* Firefox */
                    }
                `}
            </style>
            <Modal
                width="500px"
                title={type === "edit" ? "Edit Authorized Capital" : "Create Authorized Capital"}
                bodycss={commoncss.unsetPadding}
                headerActions={
                    <CloseIcon
                        className="clickable"
                        onClick={handleClose}
                    />
                }
                footerActions={
                    <>
                        <Button
                            btnColor={buttoncss.secondary}
                            label="Cancel"
                            onClick={handleClose}
                        />
                        <Button
                            btnColor={buttoncss.primary}
                            label={type === "edit" ? "Update" : "Create Authorized Capital"}
                            onClick={handleSubmit}
                            disabled={loading}
                         />
                    </>
                }
            >

                <div className={commoncss.pd1530}>
                    <span className="input-label">Class of share</span>
                    <Select
                        placeholder="Enter Class of share"
                        options={classOfShareOptions.map((option) => ({
                            label: option,
                            value: option,
                        }))}
                        className={`basic-multi-select w-100 mt-1 mb-2`}
                        classNamePrefix="select"
                        components={{
                            ...animatedComponents,
                            IndicatorSeparator: () => null,
                            DropdownIndicator: CustomDropdownIndicator,
                        }}
                        styles={customStyles}
                        value={selectedClassOfShare}
                        onChange={(selectedOption) => setSelectedClassOfShare(selectedOption)}

                    />
                    <InputGroup
                        label="No of shares"
                        inputs={[
                        <>
                          <input
                            type="text"
                            inputMode="numeric"
                            placeholder="Enter number of shares"
                            className="no-spinner"
                            value={noOfShares}
                            onChange={(e) => setNoOfShares(e.target.value)}
                            />
                        </>,
                        ]}
                    />
                    <InputGroup
                        label="Face value"
                        inputs={[
                        <>
                            <input
                                type="number"
                                placeholder="Enter face value"
                                onWheel={(e) => e.target.blur()}
                                className="no-spinner"
                                value={faceValue}
                                onChange={(e) => setFaceValue(e.target.value)}
                            />
                        </>,
                        ]}
                    />
                    <InputGroup
                        label="Amount"
                        inputs={[
                        <>
                            <input
                                type="number"
                                placeholder="Enter amount"
                                onWheel={(e) => e.target.blur()}
                                className="no-spinner"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />
                        </>,
                        ]}
                    />
                </div>
                
            </Modal>
        </>
    )

}

export default AuthorizedCapitalModal;